const cleanIdentifier = (value) => String(value ?? "").trim();

export const LABEL_IDENTIFIER_SOURCES = {
  TAG: "tag",
  SERIAL: "serial",
};

export function hasAutomaticIdentifierData(label) {
  if (!label) return false;
  return (
    label._usesAutomaticIdentifier === true ||
    Object.prototype.hasOwnProperty.call(label, "sourceTag") ||
    Object.prototype.hasOwnProperty.call(label, "sourceSerial")
  );
}

export function resolveLabelIdentifier(label, source) {
  if (source === LABEL_IDENTIFIER_SOURCES.SERIAL) {
    return cleanIdentifier(label?.sourceSerial ?? label?.serial);
  }
  return cleanIdentifier(label?.sourceTag ?? label?.tag);
}

export function applyLabelIdentifierSource(labels, source) {
  return (labels || []).map((label) => {
    if (!hasAutomaticIdentifierData(label)) return label;
    return { ...label, idEquipo: resolveLabelIdentifier(label, source) };
  });
}

export function filterSelectedLabels(labels) {
  return (labels || []).filter((label) => label?.selected !== false);
}

export function countSelectedWithoutIdentifier(labels) {
  return filterSelectedLabels(labels).filter(
    (label) => hasAutomaticIdentifierData(label) && !cleanIdentifier(label?.idEquipo)
  ).length;
}
